import { useDispatch, useSelector } from "react-redux";
import { LOADING_PROGRAM, PROGRAM } from "../store/selectors";
import { useEffect } from "react";
import { App } from "antd";
import {
  setLoading,
  setPrograms,
  deleteProgram as deleteProgramAction,
} from "../store/slices/program";
import {
  getPrograms,
  getProgramById as getProgramByIdService,
  deleteProgram as deleteProgramService,
} from "../services/programs/programs.service";

export const usePrograms = () => {
  // From App.useApp(): the static notification does not render under React 19.
  const { notification } = App.useApp();
  const dispatch = useDispatch();
  const programs = useSelector(PROGRAM);
  const loading = useSelector(LOADING_PROGRAM);

  const fetchInfo = async () => {
    dispatch(setLoading(true));
    try {
      if (programs?.length > 0) {
        setPrograms(programs);
      } else {
        const programsResponse = await getPrograms();
        programsResponse && dispatch(setPrograms(programsResponse));
      }
      dispatch(setLoading(false));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  // Forces a fresh fetch, bypassing the cache-first guard in fetchInfo.
  // Use when a view must reflect programs created elsewhere without a reload.
  const refetch = async () => {
    dispatch(setLoading(true));
    try {
      const programsResponse = await getPrograms();
      programsResponse && dispatch(setPrograms(programsResponse));
      dispatch(setLoading(false));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  const getProgramById = async (id: number) => {
    try {
      const response = await getProgramByIdService(id);
      return response;
    } catch (error: any) {
      // Caller owns the error UX; rethrow the original error so it can read
      // error.response.data.message.
      console.error("Error getting program by ID:", error);
      throw error;
    }
  };

  const deleteProgram = async (id: number): Promise<boolean> => {
    dispatch(setLoading(true));
    try {
      await deleteProgramService(id);
      dispatch(deleteProgramAction(id));
      notification["success"]({
        message: "Éxito",
        description: "El programa fue eliminado exitosamente!",
        placement: "top",
        duration: 3,
      });
      dispatch(setLoading(false));
      return true;
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Eliminación Erronea",
        description:
          error?.response?.data?.message || "El programa no pudo ser eliminado!",
        placement: "top",
        duration: 3,
      });
      return false;
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  return {
    loading,
    programs,
    deleteProgram,
    getProgramById,
    refetch,
  };
};
